import { BaseModal } from './baseModal'
import { createLogger } from '../utils/debugLogger';
import { createSelectors } from '../utils/selectorUtils';
const l = createLogger('ModalPassengers.js');

export class ModalPassengers extends BaseModal {
 
    constructor(modalName, queryStringManager = null) {
        super(modalName, queryStringManager);

        const parentLoadModalContent = this.loadModalContent.bind(this);

        this.clearSelected = () => {
            l.log(`${this.modalName}: clearSelected pax`);

            const input = document.querySelector(this.constructor.Selectors.INPUT.NUM_SELECTED);
            input.value = this.constructor.Config.DEFAULT_PAX;
        }

        this.loadModalContent = async (evt) => {
            l.log('ModalPassengers: Pre-load processing');

            // Call parent method using stored reference
            await parentLoadModalContent.call(this, evt);

            if (!this.isLoaded) {
                l.log(`${this.modalName}: base not loaded`);
                return;
            }

            // Add button handler
            this.attachHandler(
                'addButton',
                (e) => {
                    l.log('Add button clicked');
                    const input = document.querySelector(this.constructor.Selectors.INPUT.NUM_SELECTED);
                    const currentValue = parseInt(input.value) || 0;
                    input.value = currentValue == 10 ? currentValue : currentValue + 1;
                    this.handleValueChange();
                },
                `${this.constructor.Selectors.BUTTONS.ADD}`
            );

            // Remove button handler
            this.attachHandler(
                'removeButton',
                (e) => {
                    l.log('Remove button clicked');
                    const input = document.querySelector(this.constructor.Selectors.INPUT.NUM_SELECTED);
                    const currentValue = parseInt(input.value) || 0;
                    input.value = Math.max(1, currentValue - 1);
                    this.handleValueChange();
                },
                `${this.constructor.Selectors.BUTTONS.REMOVE}`
            );

            // Initial UI state
            //this.handleValueChange();
        };
    }

    static Config = {
        QUERY_STRING_KEY: 'filternumpax',
        DEFAULT_PAX: 2,
        MIN_PAX: 1,
        MAX_PAX:10
    }

    static Selectors = createSelectors({
        BUTTONS: {
            ADD: 'data-ts-pax-add',
            REMOVE: 'data-ts-pax-remove',
            CLEAR: 'data-ts-pax-clear'
        },
        INPUT: {
            NUM_SELECTED: 'data-ts-pax-numselected'
        }
    });

    static createModal(queryStringManager = null) {
        return BaseModal.create.call(this, 'ModalPassengers', queryStringManager);
    }  

    handleValueChange() {
        l.log('Value changed, updating UI');
        const currentValue = this.getSelectedValues()[1];

        // Update UI elements based on current value
        const removeButtons = document.querySelectorAll(`${this.constructor.Selectors.BUTTONS.REMOVE}`);

        removeButtons.forEach(button => {
            button.disabled = currentValue <= this.constructor.Selectors.Config.MIN_PAX;
        });
    }

    getSelectedValues() {
       
        const val = document.querySelector(this.constructor.Selectors.INPUT.NUM_SELECTED).value;

        const pax = parseInt(val) || this.constructor.Selectors.Config.DEFAULT_PAX;
        return [[this.constructor.Config.QUERY_STRING_KEY, pax.toString()]]; 
    }




}